import { inject } from '@angular/core';
import { SupplierContractWizardStore } from '../stores/supplier-contract-wizard.store';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { roleGuard } from '../../../core/guards/role.guard';
import { featureFlagGuard } from '../../../core/guards/feature-flag.guard';

export const supplierContractDraftsLoadedGuard = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  // do not load drafts for non-admin users
  if (roleGuard('USER_ADMIN')(route, state) !== true) {
    return true;
  }
  // do not load drafts if feature is disabled
  if (featureFlagGuard('supplierContractCreate')(route, state) !== true) {
    return true;
  }
  const store = inject(SupplierContractWizardStore);
  if (!store.drafts().length && !store.isDraftsLoading() && !store.draftsError()) {
    store.loadDrafts();
  }
  return true;
};
